export { STEP_URLS } from "./routing";

export const HORIZON_MODE = {
  short: "short",
  long: "long",
};
